var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJazzIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.63356H17.8267C18.8432 7.74273 19.2304 6.27578 18.6834 4.9589L16.4811 5.86909C17.1491 4.63937 16.9603 3.07558 15.9245 2.03467L14.3901 3.56941C14.453 2.24285 13.6931 0.959872 12.3959 0.422472L11.4908 2.60112C11.1036 1.24552 9.85479 0.253021 8.37851 0.253021V2.47524C7.48306 1.49243 6.04066 1.12448 4.74347 1.66188L5.61471 3.77275C4.38529 3.10463 2.82188 3.29345 1.78122 4.32952L3.41239 5.96108C2.0668 5.87394 0.750242 6.63888 0.208132 7.95576L2.24105 8.79817C0.939013 9.20969 0 10.4297 0 11.8725H2.37173C1.30687 12.7536 0.89061 14.2593 1.44724 15.6052L3.44627 14.7773C2.86544 15.9829 3.07841 17.474 4.07551 18.4714L5.75992 16.7865C5.60019 18.1857 6.37464 19.5752 7.73959 20.1417L8.57696 18.1179C9.0271 19.3622 10.2227 20.253 11.6215 20.253V17.9291C12.4976 19.0281 14.0271 19.4687 15.3921 18.9023L14.5257 16.8108C15.7309 17.3917 17.2217 17.1787 18.2188 16.1814L16.636 14.5982C18.0106 14.7241 19.3708 13.9543 19.9274 12.6132L17.7638 11.7127C19.061 11.2915 20 10.0715 20 8.63356Z",
    fill: "#F557EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJazzIcon);
export default __webpack_public_path__ + "static/media/jazz_Icon.f04f9dc1d61a4f0a107ce4c4a2d2b5a9.svg";
export { ForwardRef as ReactComponent };